import React from 'react';
import { css, Global } from '@emotion/react';
import { responsiveStyles, } from '@polestar/component-warehouse-react/helpers/responsiveStyle';
import dataTypeName from '@polestar/component-warehouse-react/dataTypeName';
/**
 * Provide initial values for CSS Custom Properties as overrides to the default values of Component Warehouse.
 * This is only necessary whenever components (like the HeroSection) need to know how much height is available outside of the menu on top.
 *
 * For example when an OfferBar with multiple lines of text is used then set
 *
 * @example
 * At a responsive value to the PolestarApp::
 *
 * <InitialPolestarAppCSSCustomProperties override={{
 *   [OfferBarCSSCustomProperties.blockSize]: {
 *      mobile: createCustomSpacing(80 / 16),
 *      tablet: createCustomSpacing(60 / 16),
 *   }
 * } as ResponsiveThemeDataObject} />
 *
 * @example
 * At a single value to the PolestarApp:
 *
 * <InitialPolestarAppCSSCustomProperties override="--cw-test-value: 1px" />
 */
const InitialPolestarAppCSSCustomProperties = ({ override, internal = false, }) => {
    // use CSS specificity to be able to override above the component what the value should be
    const selector = internal
        ? `div[data-version]`
        : `div[data-version][data-type='${dataTypeName}']`;
    if (typeof override === 'string') {
        return (React.createElement(Global, { styles: css `
          ${selector} {
            ${override}
          }
        ` }));
    }
    return (React.createElement(Global, { styles: css `
        ${selector} {
          ${responsiveStyles(override)}
        }
      ` }));
};
InitialPolestarAppCSSCustomProperties.displayName = 'InitialPolestarAppCSSCustomProperties';
export default InitialPolestarAppCSSCustomProperties;
